<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">
                
            </div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body pt-2">
        <div class="modal-body__content">
            <div class="card-body p-2">
                <form [formGroup]="userForm">
                    <div class="row">
                        <div class="col-6">
                            <div class="col-auto my-2">
                                <label for="GID" class="form-label text-small">Domain <sup style="color :red">*</sup></label>
                                <ng-select [items]="['AD001','AD005','AD003']" bindLabel="domain" bindValue="domain" placeholder="Select Domain" 
                                    formControlName="domain">
                                </ng-select>
                                <form-feedback [formGroup]="userForm" field="domain"></form-feedback>
                            </div>
                        
                            <div class="col-auto my-2">
                                <label for="Role" class="form-label text-small">Role <sup style="color :red">*</sup></label>
                                <!-- <select class="form-control form-control-sm" id="Role" placeholder="Role" formControlName="role" 
                                    [error]="userForm.get('role')">
                                    <option value="REQUESTER">REQUESTER</option>
                                    <option value="ADMIN">ADMIN</option>
                                    <option value="BUYER">BUYER</option>
                                    <option value="PO_BUYER">PO BUYER</option>
                                    <option value="QES_APPROVER">QES APPROVER</option>
                                    <option value="SUPPLIER">SUPPLIER</option>
                                    <option value="REPORTING_MANAGER">MANAGER</option>
                                </select> -->
                                <ng-select [items]="['REQUESTOR', 'ADMIN', 'BUYER', 'PO_BUYER', 'QES_APPROVER', 'SUPPLIER', 'REPORTING_MANAGER','EHS_MANAGER','FACTORY_PROCUREMENT']"
                                    bindLabel="role" 
                                    bindValue="role"
                                    placeholder="Select Role"
                                    (change)="onAccessChange()"
                                    formControlName="role">
                                </ng-select>
                                <form-feedback [formGroup]="userForm" field="role"></form-feedback>
                            </div>
                            <div class="col-auto my-2">
                                <label for="Username" class="form-label text-small">Username <sup style="color :red">*</sup></label>
                                <input type="text" class="form-control form-control-sm" id="Username" placeholder="Username" formControlName="user_name"
                                    [error]="userForm.get('user_name')">
                                <form-feedback [formGroup]="userForm" field="user_name"></form-feedback>
                            </div>
                            <div class="col-auto my-2">
                                <label for="Access Type" class="form-label text-small">Access Type<sup style="color :red">*</sup></label>
                                <ng-select [items]="['FULL', 'MODULE_ACCESS']" (change)="onAccessChange()"
                                    bindLabel="accessType" 
                                    bindValue="accessType"
                                    placeholder="Select Access Type"
                                    formControlName="accessType">
                                </ng-select>
                                <form-feedback [formGroup]="userForm" field="role"></form-feedback>
                            </div>

                            <div class="col-auto my-2">
                                <label for="Mobile No" class="form-label text-small">Mobile No<sup style="color :red">*</sup></label>
                                <input type="text" class="form-control form-control-sm" id="Mobile No" placeholder="Mobile No" formControlName="mobile_no"
                                    [error]="userForm.get('mobile_no')">
                                <form-feedback [formGroup]="userForm" field="mobile_no"></form-feedback>
                            </div>
                            <div class="col-auto my-2">
                                <label for="Location" class="form-label text-small">Location <sup style="color :red">*</sup></label>
                                <input type="text" class="form-control form-control-sm" id="Location" placeholder="Location" formControlName="location"
                                    [error]="userForm.get('location')"> 
                                <form-feedback [formGroup]="userForm" field="location"></form-feedback>
                            </div>
                            <div class="col-auto my-2">
                                <label for="Company Code" class="form-label text-small">Company Code <sup style="color :red">*</sup></label>
                                <!-- <input type="text" class="form-control form-control-sm" id="Company Code" placeholder="Company Code" formControlName="company_code"
                                    [error]="userForm.get('company_code')">  -->
                                <ng-select [items]="masterData['COMPANY_CODE']"
                                    [multiple]="USER_RULES.company_code[userForm.get('role')?.value]"
                                    placeholder="Select"
                                    formControlName="company_code">
                                </ng-select>
                                <form-feedback [formGroup]="userForm" field="company_code"></form-feedback>
                            </div>
                            <ng-container *ngIf="userForm.get('role')?.value === 'BUYER'">
                                <div class="col-auto my-2">
                                    <label for="Threshold From" class="form-label text-small">Threshold From <sup style="color :red">*</sup></label>
                                    <input type="text" class="form-control form-control-sm" id="Threshold From" placeholder="Threshold From" formControlName="netprice_start"
                                        [error]="userForm.get('netprice_start')" required> 
                                    <form-feedback [formGroup]="userForm" field="netprice_start"></form-feedback>
                                </div>
                                <div class="col-auto my-2">
                                    <label for="IM/DM" class="form-label text-small">IM/DM <sup style="color :red">*</sup></label>
                                    <!-- <input type="text" class="form-control form-control-sm" id="IM/DM" placeholder="IM/DM" formControlName="direct_indirect"
                                        [error]="userForm.get('direct_indirect')">  -->
                                    <ng-select [items]="['Direct', 'Indirect']"
                                        placeholder="Select"
                                        formControlName="direct_indirect">
                                    </ng-select>
                                    <form-feedback [formGroup]="userForm" field="direct_indirect"></form-feedback>
                                </div>
                                <div class="col-auto my-2">
                                    <label for="ESN Code" class="form-label text-small">ESN Code <sup style="color :red">*</sup></label>
                                    <ngx-bootstrap-multiselect [settings]="mySettings" class="text-white" [options]="ESNList"  [texts]="myTexts" formControlName="esn"></ngx-bootstrap-multiselect>
                                    <form-feedback [formGroup]="userForm" field="esn"></form-feedback>
                                </div>
                                <!-- <ng-container > -->
                                <div class="col-auto my-2" *ngIf="userForm.get('role')?.value === 'BUYER'">
                                    <label for="EnablePurchaseGroupFilter" class="form-label text-small">
                                        Enable Purchase Group Filter <sup style="color :red">*</sup>
                                    </label>
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="EnablePurchaseGroupFilter"
                                            formControlName="enable_p_group_filter">
                                        <label class="form-check-label" for="EnablePurchaseGroupFilter">
                                            {{ userForm.get('enable_p_group_filter')?.value ? 'Enabled' : 'Disabled' }}
                                        </label>
                                    </div>
                                </div>
                            <!-- </ng-container> -->
                            </ng-container>
                        </div>
                        <div class="col-6">
                            <div class="col-auto my-2">
                                <label for="GID" class="form-label text-small">GID <sup style="color :red">*</sup></label>
                                <input type="text" class="form-control form-control-sm" id="GID" placeholder="GID" formControlName="gid"
                                    [error]="userForm.get('gid')"
                                    [ngClass]="{
                                        'is-invalid' : !isValidItracerUser
                                    }">
                                <form-feedback [formGroup]="userForm" field="gid"></form-feedback>
                                <div *ngIf="!isValidItracerUser" class="invalid-feedback d-block"> User not found</div>
                            </div>
                            <ng-container *ngIf="userForm.get('role')?.value === 'BUYER'">
                                <div class="col-auto my-2">
                                    <label for="Currency" class="form-label text-small">Currency <sup style="color :red">*</sup></label>
                                    <select formControlName="currency" class="form-control form-control-sm">
                                        <option *ngFor="let value of currency" [value]="value.code">{{value.code}} - {{value.name}}</option>
                                    </select>
                                    <form-feedback [formGroup]="userForm" field="currency"></form-feedback>
                                </div>
                            </ng-container>
                            <div class="col-auto my-2">
                                <label for="Email ID" class="form-label text-small">Email ID <sup style="color :red">*</sup></label>
                                <input type="text" class="form-control form-control-sm" id="Email ID" placeholder="Email ID" formControlName="user_email"
                                    [error]="userForm.get('user_email')"> 
                                <form-feedback [formGroup]="userForm" field="user_email"></form-feedback>
                            </div>
                            <div class="col-auto my-2">
                                <label for="Email ID" class="form-label text-small">Reporting Manager <sup style="color :red">*</sup></label>
                                <input type="text" class="form-control form-control-sm" id="Reporting Manager" placeholder="Reporting Manager" formControlName="manager_gid"
                                    [error]="userForm.get('manager_gid')"> 
                                <form-feedback [formGroup]="userForm" field="manager_gid"></form-feedback>
                            </div>
                            <div class="col-auto my-2" *ngIf="enableModuleAccess">
                                <label for="Access List" class="form-label text-small">Access List<sup style="color :red">*</sup></label>
                                <ng-select [items]="accessList" [multiple]="true"
                                    bindLabel="accessList" 
                                    bindValue="accessList"
                                    placeholder="Select Access List"
                                    formControlName="accessList">
                                </ng-select>
                                <form-feedback [formGroup]="userForm" field="role"></form-feedback>
                            </div>

                            <div class="col-auto my-2">
                                <label for="Plant Code" class="form-label text-small">Plant Code <sup style="color :red">*</sup></label>
                                <!-- <input type="text" class="form-control form-control-sm" id="Plant Code" placeholder="Plant Code" formControlName="plant_code"
                                    [error]="userForm.get('plant_code')"> -->
                                <ng-select [items]="masterData['PLANT']"
                                    [multiple]="true"
                                    placeholder="Select"
                                    formControlName="plant_code">
                                </ng-select>
                                <form-feedback [formGroup]="userForm" field="plant_code"></form-feedback>
                            </div>
                            <ng-container *ngIf="userForm.get('role')?.value === 'BUYER'">
                                <div class="col-auto my-2">
                                    <label for="Commodity" class="form-label text-small">Commodity <sup style="color :red">*</sup></label>
                                    <input type="text" class="form-control form-control-sm" id="Commodity" placeholder="Commodity" formControlName="commodity"
                                        [error]="userForm.get('commodity')"> 
                                    <form-feedback [formGroup]="userForm" field="commodity"></form-feedback>
                                </div>
                                <div class="col-auto my-2">
                                    <label for="Threshold To" class="form-label text-small">Threshold To <sup style="color :red">*</sup></label>
                                    <input type="text" class="form-control form-control-sm" id="Threshold To" placeholder="Threshold To" formControlName="netprice_end"
                                        [error]="userForm.get('netprice_end')" required> 
                                    <form-feedback [formGroup]="userForm" field="netprice_end"></form-feedback>
                                </div>
                            </ng-container>
                            <div class="col-auto my-2">
                                <label for="Division" class="form-label text-small">Purchase Organization <sup style="color :red">*</sup></label>
                                <!-- <input type="text" class="form-control form-control-sm" id="Division" placeholder="Division" formControlName="division"
                                    [error]="userForm.get('division')">  -->
                                <ng-select [items]="masterData['DIVISION']"
                                    [multiple]="USER_RULES.division[userForm.get('role')?.value]"
                                    placeholder="Select"
                                    formControlName="division">
                                </ng-select>
                                <form-feedback [formGroup]="userForm" field="division"></form-feedback>
                            </div>
                            <ng-container *ngIf="userForm.get('role')?.value === 'BUYER'">
                                <div class="col-auto my-2">
                                    <label for="Purchase Group" class="form-label text-small">Purchase Group</label>
                                    <tag-input [(ngModel)]="purchase_group" [maxItems]='4' placeholder="Enter Group Name" 
                                    formControlName="purchase_group" style="text-transform:uppercase; height: none;" value="updatedUser.purchase_group"
                                    class="form-control tag-in"></tag-input>
                                </div>
                            </ng-container>
                            
                            <!-- <div class="col-auto my-2" *ngIf="userForm.get('role')?.value ==='FACTORY_PROCUREMENT'">
                                <label for="Purchasing Organization" class="form-label text-small">Purchasing Organization</label>
                                <input type="text" class="form-control form-control-sm" id="p_org" placeholder="Purchasing Organization" formControlName="p_org"
                                [error]="userForm.get('p_org')"> 
                            <form-feedback [formGroup]="userForm" field="p_org"></form-feedback>
                            </div> -->
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <button class="btn btn-outline-primary mx-2" (click)="bsModalRef.hide()">Cancel</button>
            <button class="btn btn-primary mx-2 text-white" (click)="updateInfo()" 
                [disabled]="!userForm.valid || !isValidItracerUser">
                <span *ngIf="userActionType === 'CREATE'">Create</span>
                <span *ngIf="userActionType === 'UPDATE'">Update</span>
                <span *ngIf="userActionType === 'COPY'">Copy User</span>
            </button>
        </div>
    </div>
</section>